<template>
  <div id="page-wrapper">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12">
          <div class="table__title_with-button">
            <h1>История входов</h1>
          </div>
        </div>
      </div>
      <div>
        <div class="col-lg-12">
          <div class="panel panel-default">
            <FilterForm
              :custom-fields-list="filterFields"
              @search="searchRecords"
              @on-reset-filters="resetFilters"
              :disabled="notFound && !searchData"
            />
            <Preloader v-if="isLoadingNow && !notFound" />
            <div v-else-if="!isLoadingNow && !notFound" class="panel-body">
              <div class="table-responsive">
                <table class="table table_with-image">
                  <thead>
                    <tr>
                      <th
                        v-for="column in columnNames"
                        :index="column"
                        class="list__column"
                      >
                        <span
                          v-if="isOrderColumn(column)"
                          class="list__column_with-icon"
                          @click="changeListOrder(column)"
                        >
                          {{ column }}
                          <i v-if="column === orderColumn" :class="orderIconCss" />
                        </span>
                        <span v-else>{{ column }}</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="item in filteredRecords"
                      :key="item.id"
                      class="row__container"
                    >
                      <td class="list__row">
                        <router-link :to="`/users/${item.user_id.id}`" target="_blank">
                          {{ item.user_id.surname }} {{ item.user_id.name }}
                        </router-link>
                      </td>
                      <td class="list__row">
                        {{ item.user_id.role_id.name }}
                      </td>
                      <td class="list__row">
                        {{ item.created_at }}
                      </td>
                      <td class="list__row">
                        {{ item.with_failure ? 'Провал' : 'Успех' }}
                      </td>
                      <td class="list__row">
                        {{ item.failure_reason || '-' }}
                      </td>
                      <td class="list__row">
                        <ImageRow
                          subfolder="snapshots"
                          :src="item.snapshot_url"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="list__footer">
                <div>
                  <Pagination
                    :pages-counter="pagesCounter"
                    :current-page="currentPage"
                    @select="(page) => changePage(page, 'getAllRecords')"
                  />
                </div>
              </div>
            </div>
            <div
              v-if="notFound && !isLoadingNow"
              class="table__content_empty-results"
            >
              <p class="">Ничего не найдено</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FilterForm from "@/_shared/features/table/FilterForm";
import Pagination from "@/_shared/components/ui/Pagination";
import Preloader from "@/_shared/components/ui/Preloader";
import ImageRow from "@/_shared/features/table/ImageRow";
import { lists } from "@/user/constants";
import httpClient from "@/_shared/http-client";
import {
  usePagination,
  useTableHelper,
  useOrderFilter,
  useRoleIdentifier,
} from "@/_shared/mixins";
import { pagination, string } from "@/_shared/utils";
const { getPagesCounter } = pagination;
const { camelToSnakeCase } = string;
export default {
  mixins: [usePagination, useTableHelper, useOrderFilter, useRoleIdentifier],
  components: {
    FilterForm,
    Pagination,
    Preloader,
    ImageRow,
  },
  data() {
    return {
      orderFields: lists.loginHistory.orderFields,
      orderColumn: 'Дата попытки',
      searchData: [],
      searchingParams: null,
      isLoadingNow: true,
      records: [],
      filteredRecords: [],
      notFound: false,
    };
  },
  provide() {
    return {
      createdAtFilterLabel: 'Дата попытки',
      withoutUpdateDateFilter: true,
    };
  },
  watch: {
    "$route.fullPath": {
      async handler() {
        this.resetFilters();
      },
    },
  },
  computed: {
    columnNames() {
      return lists.loginHistory.columnNames;
    },
    filterFields() {
      return lists.loginHistory.filterFields;
    },
  },
  methods: {
    async resetFilters() {
      this.searchingParams = null;
      this.searchData = [];
      this.records = await this.getAllRecords(1);
    },
    async changeListOrder(columnName) {
      this.toggleOrder(columnName);
      if (this.searchingParams) {
        return await this.searchRecords(this.searchData);
      }
      await this.getAllRecords(1);
    },
    prepareItems(filterName, filterItems) {
      filterName = camelToSnakeCase(filterName);
      if (filterName === "id") {
        return `filter=${filterName},sw,${filterItems}`;
      }
      if (filterName === "created_at") {
        return filterItems.length > 1
          ? `filter=${filterName},bt,${filterItems[0]},${filterItems[1]}`
          : `filter=${filterName},sw,${filterItems[0]}`;
      } else {
        const booleanValues = ["1", "0"];
        if (booleanValues.includes(filterItems)) {
          return `filter=${filterName},cs,${+filterItems}`;
        }
        return `filter=${filterName},cs,${filterItems}`;
      }
    },
    async searchRecords(searchData) {
      this.isLoadingNow = true;
      if (searchData.length > 0) {
        let filter = [];
        searchData.forEach((item) => {
          for (let itemKey in item) {
            filter.push(this.prepareItems(itemKey, item[itemKey]));
          }
        });
        let searchingParams = filter.join("&");
        searchingParams = this.addOrderQueryParam(searchingParams);
        searchingParams += '&join=users,roles';
        this.searchingParams = searchingParams;
        this.searchData = searchData;
        searchingParams += `&page=1`;

        const url = `generated/records/login_history?${searchingParams}`;
        const response = await httpClient.get(url);

        this.pagesCounter = getPagesCounter(response.data.results);
        this.currentPage = 1;
        this.filteredRecords = response.data.records;
        this.notFound = !this.filteredRecords.length > 0 || false;
        this.isLoadingNow = false;
      }
    },
    async getAllRecords(page = 1) {
      this.isLoadingNow = true;

      let url = `generated/records/login_history?page=${page}`;
      url = this.addOrderQueryParam(url);
      url += '&join=users,roles';
      const response = await httpClient.get(url);
      this.redirectIfNotVip();
      this.filteredRecords = response.data.records;
      this.notFound = !!(this.filteredRecords.length < 1);

      const pagesCounter = getPagesCounter(response.data.results);
      this.usePagination(page, pagesCounter);
      this.isLoadingNow = false;
    },
  },
  async mounted() {
    await this.getAllRecords();
  },
};
</script>



// WEBPACK FOOTER //
// src/user/pages/LoginHistoryPage.vue